import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  return Yup.object({
    moduleId: Yup.string().required(requiredMessage),
    menuId: Yup.string().required(requiredMessage),
    name: Yup.string().required(requiredMessage),
    code: Yup.string(),
    parentId: Yup.number(),
    active: Yup.string(),
  })
}

export default makeValidationSchema
